import { render, staticRenderFns } from "./result-section.vue?vue&type=template&id=663e9662&scoped=true&"
import script from "./result-section.vue?vue&type=script&lang=js&"
export * from "./result-section.vue?vue&type=script&lang=js&"
import style0 from "./result-section.vue?vue&type=style&index=0&id=663e9662&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663e9662",
  null
  
)

export default component.exports